import store from '@/store/index'
import axios from "@/api/axios"
import publicFn from '@/publicFn/baseFn'
import {MessageBox} from "element-ui";


function getGWC(type='drug') {
    let obj = {
        "SearchCondition" : {
            // "CHPProductSortGroup" : type,
            "CompanyId" : store.state.users.user.Company.CompanyId,
            "ChooseId" : store.state.physicianVisits.xzConsulting,
            "bDelete" : 0,
            "IndexMin" : 1,
            "IndexMax" : 50,
            // "CHPStatus" : "1,2"
        },
        "ProductSource" : "",
        "ReturnInfo" : {
            "ProductRelation" :
                {
                    "ShopProduct" : 1,
                    "Product" :
                        {
                            "Brand" : 1,
                            "Sort" : 1
                        }
                },
            // "InspectionOrder" : 1
        },
        "token" : {
            "sToken" : "AC01E3D93B3F108B690095558CEAE3EC",
            "TimeSpan" : "1688113906"
        }
    }
   return  axios.post(publicFn.getUrl('getChooseList'), obj)
}


function getCp(type='drug') {
    return  axios.post(publicFn.getUrl('priceSortList'), {
        "SearchCondition" : {
            "ShopId" : store.state.bases.shop.ShopId,
            "PriceEnd" : 0,
            "PSId" : "",
            "IndexMin" : 0,
            "BrandId" : "",
            "IndexMax" : 0,
            "ShopBrandOrder" : 1,
            "PriceStart" : 0,
            "SortKey" : type
        },
        "ReturnInfo" : {
            "ShopProduct" : 1,
            "Product" : {
                "Brand" : 1,
                "Sort" : 0
            }  },
        "token" : {
            "sToken" : "8C29167B0ADF034F582C73D350369D8E",
            "TimeSpan" : "1688355555"
        },
        "SearchString" : ""
    })
}



function numbh(num, id) {
    return axios.post(publicFn.getUrl('UpdateChooseProductAmount'), {
        "token": {
            "sToken": "E0B1486293C779EEE7CD24AF277703D7",
            "TimeSpan": "1574670974"
        },
        "o":{
            "CHPAmount":num,
            "ChooseProductId":id
        }
    })
}



function getTjnr () {
    return axios.post(publicFn.getUrl('recLensModule1'), {
        "token" : {    "sToken" : "DCBB158A412515E8440FC2E97B16C76D",    "TimeSpan" : "1765848372"  },
        "ChooseId" : store.state.physicianVisits.xzConsulting,
        "bDisplay" : "1"
    })
}


function saveFA(arr) {
    let obj = []

    for (let i = 0 ; i < arr.length; i++) {
        obj.push(JSON.parse(JSON.stringify(arr[i])))
    }

    if (obj.length < 1) {
        return axios.post(publicFn.getUrl('S_OP_ALL_DeleteByType'), {
            "token": {
                "sToken": "45B94332B4508AAE81295EB24C982654",
                "TimeSpan": "1623829629"
            },
            ChooseId: store.state.physicianVisits.xzConsulting,
            "S_OP_Model":"S_OP_IO",
            "S_OP_Type":"Inspection"
        })
    }

    for (let i = 0; i < obj.length; i++) {
        if (obj[i].S_OP_Json.S_OP_IO_DCOD && obj[i].S_OP_Json.S_OP_IO_DCOD !== 0) {
            if (!obj[i].S_OP_Json.S_OP_IO_DSOD && obj[i].S_OP_Json.S_OP_IO_DSOD !== 0) {
                return MessageBox(`处方${i+1}的OD球镜缺少数据，请填写！`, '提示')
            }
            if (!obj[i].S_OP_Json.S_OP_IO_XOD && obj[i].S_OP_Json.S_OP_IO_XOD !== 0) {
                return MessageBox(`处方${i+1}的OD轴向缺少数据，请填写！`, '提示')
            }
        }
        if (obj[i].S_OP_Json.S_OP_IO_DCOS && obj[i].S_OP_Json.S_OP_IO_DCOS !== 0) {
            if (!obj[i].S_OP_Json.S_OP_IO_DSOS && obj[i].S_OP_Json.S_OP_IO_DSOS !== 0) {
                return MessageBox(`处方${i+1}的OS球镜缺少数据，请填写！`, '提示')
            }
            if (!obj[i].S_OP_Json.S_OP_IO_XOS && obj[i].S_OP_Json.S_OP_IO_XOS !== 0) {
                return MessageBox(`处方${i+1}的OS轴向缺少数据，请填写！`, '提示')
            }
        }

        if (obj[i].S_OP_Json.S_OP_IO_XOD && obj[i].S_OP_Json.S_OP_IO_XOD !== 0) {
            if (!obj[i].S_OP_Json.S_OP_IO_DSOD && obj[i].S_OP_Json.S_OP_IO_DSOD !== 0) {
                return MessageBox(`处方${i+1}的OD球镜缺少数据，请填写！`, '提示')
            }
            if (!obj[i].S_OP_Json.S_OP_IO_DCOD && obj[i].S_OP_Json.S_OP_IO_DCOD !== 0) {
                return MessageBox(`处方${i+1}的OD柱镜缺少数据，请填写！`, '提示')
            }
        }
        if (obj[i].S_OP_Json.S_OP_IO_XOS && obj[i].S_OP_Json.S_OP_IO_XOS !== 0) {
            if (!obj[i].S_OP_Json.S_OP_IO_DSOS && obj[i].S_OP_Json.S_OP_IO_DSOS !== 0) {
                return MessageBox(`处方${i+1}的OS球镜缺少数据，请填写！`, '提示')
            }
            if (!obj[i].S_OP_Json.S_OP_IO_DCOS && obj[i].S_OP_Json.S_OP_IO_DCOS !== 0) {
                return MessageBox(`处方${i+1}的OS柱镜缺少数据，请填写！`, '提示')
            }
        }

        // console.log(obj)

        if (obj[i].S_OP_Json.S_OP_IO_Type != 7) {
            if (!obj[i].S_OP_Json.S_OP_IO_PDOD && obj[i].S_OP_Json.S_OP_IO_PDOD !== 0) {
                return MessageBox(`处方${i+1}的OD瞳距缺少数据，请填写！`, '提示')
            }
            if (!obj[i].S_OP_Json.S_OP_IO_PDOS && obj[i].S_OP_Json.S_OP_IO_PDOS !== 0) {
                return MessageBox(`处方${i+1}的OS瞳距缺少数据，请填写！`, '提示')
            }

        }

        // if (obj[i].S_OP_Json.S_OP_IO_Type == 0) {
        //     if (obj[i].S_OP_Json.S_OP_IO_FrameType != '单光') {
        //         if (!obj[i].S_OP_Json.S_OP_IO_PHOD && obj[i].S_OP_Json.S_OP_IO_PHOD !== 0) {
        //             return MessageBox(`处方${i+1}的OD瞳高缺少数据，请填写！`, '提示')
        //         }
        //         if (!obj[i].S_OP_Json.S_OP_IO_PHOS && obj[i].S_OP_Json.S_OP_IO_PHOS !== 0) {
        //             return MessageBox(`处方${i+1}的OS瞳高缺少数据，请填写！`, '提示')
        //         }
        //     }
        // }

        // let ysid = exid
        //
        // if (ysid) {
        //     obj[i].S_OP_ExpertId = ysid
        // }else {
        //     obj[i].S_OP_ExpertId = store.state.users.employees?store.state.users.employees.ExpertId:'00000000-0000-0000-0000-000000000000'
        // }
        obj[i].S_OP_Json = publicFn.conversionJson(obj[i].S_OP_Json)
    }

   return  axios.post(publicFn.getUrl('S_all_Normal_SaveList'), {
        "token": {
            "TimeSpan": 1566827733,
            "sToken": "768DCAFFF869CD61372790C2738012EC"
        },
        lo: obj
    })
}


function getcflist() {
    return axios.post(publicFn.getUrl('PrescriptionTemp_GetList'), {
        "token": {
            "sToken": "45B94332B4508AAE81295EB24C982654",
            "TimeSpan": "1623829629"
        },
        "SearchCondition": {
            "PTName": "",
            "ExpertId": store.state.users.employees.ExpertId,
            "ShopId":  store.state.bases.shop.ShopId,
            "PageIndex": 0,
            "PageSize": 0
        }
    })
}

function addnmb(obj,arr) {
    return axios.post(publicFn.getUrl('PrescriptionTemp_Insert'), {
        "token": {
            "sToken": "45B94332B4508AAE81295EB24C982654",
            "TimeSpan": "1623829629"
        },
        o: {
            "PTName": obj.n,
            "PTDescription": obj.s,
            "PTCompanyId": store.state.users.user.Company.CompanyId,
            "PTShopId": store.state.bases.shop.ShopId,
            "PTExpertId": store.state.users.employees.ExpertId,
            "PTDisease": obj.b,
            "PTDetails": arr
        }
    })
}


function cfxx(id) {
    return axios.post(publicFn.getUrl('PrescriptionTemp_Get'), {
        "token": {
            "sToken": "45B94332B4508AAE81295EB24C982654",
            "TimeSpan": "1623829629"
        },
        "SearchCondition": {
            "PTId": id,
            "ShopId": store.state.bases.shop.ShopId,
        }
    })
}


function upmbfn (obj){
    return axios.post(publicFn.getUrl('PrescriptionTemp_Update'), {
        "token": {
            "sToken": "45B94332B4508AAE81295EB24C982654",
            "TimeSpan": "1623829629"
        },
        o: obj
    })
}


function delemb(id) {
    return axios.post(publicFn.getUrl('PrescriptionTemp_DeleteById'), {
        "token": {
            "sToken": "45B94332B4508AAE81295EB24C982654",
            "TimeSpan": "1623829629"
        },
        "Id": id
    })
}

export {
    getGWC,
    getCp,
    numbh,
    getTjnr,
    saveFA,
    getcflist,
    addnmb,
    cfxx,
    upmbfn,
    delemb
}
